define("js/footer",["jquery","collapse","isMobile"],function(e,o,i){"use strict";i()&&o(".footer-links h4",!1)});
